var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[(_vm.reload)?_c('div',{style:(_vm.styleChartName),attrs:{"id":_vm.hid}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }